<template>
  <div :id="id" class="list-component">
    <v-toolbar dense flat v-if="headerVisibility">
      <v-btn
        :id="id + '-deleteButton'"
        fab
        class="ma-2"
        small
        color="tesfriRaspberry"
        @click="onRemoveSelected()"
        v-if="deleteButtonVisibility"
        v-bind:disabled="isDeleteButtonDisabled === true"
      >
        <v-icon>mdi-trash-can-outline</v-icon>
      </v-btn>
      <v-btn
        :id="id + '-addButton'"
        fab
        class="ma-2"
        small
        color="tesfriRaspberry"
        @click="onAddSelected()"
        v-if="addButtonVisibility"
        v-bind:disabled="isAddButtonDisabled === true"
      >
        <v-icon medium>mdi-plus</v-icon>
      </v-btn>

      <v-spacer></v-spacer>

      <v-btn
        :id="id + '-exportButton'"
        fab
        class="ma-2"
        small
        color="tesfriRaspberry"
        @click="onExport()"
        v-if="exportButtonVisibility"
        v-bind:disabled="isExportButtonDisabled === true"
      >
        <v-icon>fas fa-file-csv</v-icon>
      </v-btn>

      <v-btn c fab class="ma-2" small color="tesfriRaspberry" @click="clearFilters()" v-if="clearFilterButtonVisibility">
        <v-icon>mdi-filter-remove-outline</v-icon>
      </v-btn>
      <v-btn fab class="ma-2" small color="tesfriRaspberry" @click="toggleCheckboxVisibility()" v-if="toggleCheckboxIsVisibility">
        <v-icon>fas fa-tasks</v-icon>
      </v-btn>
    </v-toolbar>

    <div class="list-content">
      <div class="grid-column-configuration">
        <ag-grid-vue
          class="ag-theme-material"
          id="myGrid"
          :columnDefs="columnDefs"
          :gridOptions="gridOptions"
          :defaultColDef="defaultColDef"
          :rowData="rowData"
          :editType="editType"
          @grid-ready="onGridReady"
          :enableCellTextSelection="true"
          :frameworkComponents="frameworkComponents"
          @gridSizeChanged="onGridSizeChanged"
          @rowSelected="onRowSelected"
          @selectionChanged="onSelectionChanged"
          :rowClicked="onRowClicked"
          :rowDoubleClicked="onRowDoubleClicked"
          @rowValueChanged="onRowValueChanged"
          @rowEditingStarted="onRowEditingStarted"
          @rowEditingStopped="onRowEditingStopped"
          @cellEditingStarted="onCellEditingStarted"
          @cellEditingStopped="onCellEditingStopped"
          @columnEverythingChanged="onColumnEvent"
          @columnRowGroupChanged="onColumnEvent"
          @columnValueChanged="onColumnEvent"
          @columnMoved="onColumnEvent"
          @columnVisible="onColumnEvent"
          @columnGroupOpened="onColumnEvent"
          @columnResized="onColumnEvent"
          @columnPinnedCountChanged="onColumnEvent"
          @cellClicked="onCellClicked"
          :overlayLoadingTemplate="overlayLoadingTemplate"
          :overlayNoRowsTemplate="overlayNoRowsTemplate"
          @rowDataChanged="onRowDataChanged"
          :pagination="pagination"
          :localeText="localeText"
          @model-updated="onModelUpdated"
          :pinnedBottomRowData="pinnedBottomRowData"
          @first-data-rendered="onFirstDataRendered"
        >
        </ag-grid-vue>

        <v-card class="column-configuration ">
          <v-container fluid>
            <v-switch
              v-for="col in columns"
              :key="col.id"
              v-model="col.visible"
              :label="col.name"
              @change="toggleColumnVisibility(col.id)"
              color="success"
            ></v-switch>
          </v-container>
        </v-card>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "listComponent.scss";
</style>

<script type="text/javascript">
import "ag-grid-community/dist/styles/ag-grid.css";
import "@/assets/ag-theme-material-before.scss";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import "@/assets/ag-theme-material-after.scss";

import Vue from "vue";
import { AgGridVue } from "ag-grid-vue";

import moment from "moment";
import "moment/locale/fr";
moment.locale("fr");

import comboboxRenderer from "../combobox/comboboxComponent.vue";
import checkboxRenderer from "./renderer/checkboxRenderer.vue";
import buttonColumnRenderer from "./renderer/buttonColumnRenderer.vue";
import buttonDisablableColumnRenderer from "./renderer/buttonDisablableColumnRenderer.vue";
import buttonHideColumnRenderer from "./renderer/buttonHideColumnRenderer.vue";
import badgeColumnRenderer from "./renderer/badgeColumnRenderer.vue";
import iconeColumnRenderer from "./renderer/iconeColumnRenderer.vue";

import { AllCommunityModules } from "ag-grid-community";
import { AutocompleteSelectCellEditor } from "ag-grid-autocomplete-editor";

export default {
  props: ["controller", "id"],

  data() {
    return {
      columnDefs: [],
      gridApi: null,
      gridColumnApi: null,
      gridOptions: null,
      defaultColDef: {},
      rowData: [],
      editType: "cell",
      columns: [],
      editingOldValues: null,
      editingNewValues: null,
      frameworkComponents: null,
      isReady: false,
      addButtonVisibility: false,
      deleteButtonVisibility: false,
      exportButtonVisibility: false,
      clearFilterButtonVisibility: true,
      toggleCheckboxIsVisibility: true,
      hasRows: false,
      dataSource: null,
      title: "",
      isAddButtonDisabled: true,
      isDeleteButtonDisabled: true,
      isExportButtonDisabled: true,
      overlayLoadingTemplate: null,
      overlayNoRowsTemplate: null,

      //Device width
      screenW: screen.width,
      tabletW: 768,
      modules: { AllCommunityModules, AutocompleteSelectCellEditor },

      pinnedBottomRowData: null,
      pagination: true
    };
  },

  computed: {
    headerVisibility: function() {
      return (
        this.deleteButtonVisibility ||
        this.addButtonVisibility ||
        this.exportButtonVisibility ||
        this.clearFilterButtonVisibility ||
        this.toggleCheckboxIsVisibility
      );
    }
  },

  watch: {
    "gridOptions.columnApi": function() {
      this.retrieveColumns();
    }
  },

  components: {
    AgGridVue,
    // eslint-disable-next-line vue/no-unused-components
    comboboxRenderer: comboboxRenderer,
    // eslint-disable-next-line vue/no-unused-components
    checkboxRenderer: checkboxRenderer,
    // eslint-disable-next-line vue/no-unused-components
    buttonColumnRenderer: buttonColumnRenderer,
    // eslint-disable-next-line vue/no-unused-components
    buttonDisablableColumnRenderer: buttonDisablableColumnRenderer,
    // eslint-disable-next-line vue/no-unused-components
    buttonHideColumnRenderer: buttonHideColumnRenderer,
    // eslint-disable-next-line vue/no-unused-components
    badgeColumnRenderer: badgeColumnRenderer,
    // eslint-disable-next-line vue/no-unused-components
    iconeColumnRenderer: iconeColumnRenderer
  },

  methods: {
    // eslint-disable-next-line no-unused-vars
    onGridSizeChanged(params) {},

    onColumnEvent() {
      this.saveColumnState();
      this.retrieveColumns();
    },

    saveColumnState() {
      //console.log(JSON.stringify(this.gridOptions.columnApi.getColumnState()))
    },

    retrieveColumns() {
      let tmpColumns = [];
      for (let col of this.gridOptions.columnApi.getColumnState()) {
        let name = this.columnDefs.find(c => c.field === col.colId).headerName;
        if (name.trim()) {
          tmpColumns.push({ id: col.colId, name: name, visible: !col.hide });
        }
      }
      this.columns = tmpColumns;
    },

    toggleCheckboxVisibility() {
      let columnConfiguration = document.body.querySelector(`#${this.id} .column-configuration`);
      columnConfiguration.classList.toggle("opened");
    },

    toggleColumnVisibility(data) {
      if (
        this.gridOptions.columnApi.getColumnState().find(col => {
          return col.colId == data;
        }).hide
      ) {
        this.gridOptions.columnApi.setColumnVisible(data, true);
      } else {
        this.gridOptions.columnApi.setColumnVisible(data, false);
      }
    },

    // customKeyboardNavigation(params) {
    //   var previousCell = params.previousCellPosition;
    //   var suggestedNextCell = params.nextCellPosition;

    //   var KEY_UP = 38;
    //   var KEY_DOWN = 40;
    //   var KEY_LEFT = 37;
    //   var KEY_RIGHT = 39;

    //   switch (params.key) {
    //     case KEY_DOWN:
    //       previousCell = params.previousCellPosition;
    //       // set selected cell on current cell + 1
    //       this.gridOptions.api.forEachNode(node => {
    //         if (previousCell.rowIndex + 1 === node.rowIndex) {
    //           node.setSelected(true);
    //         }
    //       });
    //       return suggestedNextCell;
    //     case KEY_UP:
    //       previousCell = params.previousCellPosition;
    //       // set selected cell on current cell - 1
    //       this.gridOptions.api.forEachNode(node => {
    //         if (previousCell.rowIndex - 1 === node.rowIndex) {
    //           node.setSelected(true);
    //         }
    //       });
    //       return suggestedNextCell;
    //     case KEY_LEFT:
    //     case KEY_RIGHT:
    //       return suggestedNextCell;
    //     default:
    //       throw "this will never happen, navigation is always on of the 4 keys above";
    //   }
    // },

    //Permet créer une colonne numérique
    numericColumn(name, columnParams) {
      let defaultColumnParams = {
        headerName: name,
        field: name,
        filter: "agNumberColumnFilter",
        filterParams: { suppressAndOrCondition: true },
        type: "numericColumn"
      };
      //Permet de remplacer des params de "defaultColumnParams" avec ceux passés en param (columnParams)
      return Object.assign({}, defaultColumnParams, columnParams);
    },

    //Permet de créer une colonne text
    textColumn(name, columnParams) {
      let defaultColumnParams = {
        headerName: name,
        field: name,
        filter: "agTextColumnFilter",
        filterParams: { suppressAndOrCondition: true },
        cellStyle: { "text-align": "left" }
      };
      //Permet de remplacer des params de "defaultColumnParams" avec ceux passés en param (columnParams)
      return Object.assign({}, defaultColumnParams, columnParams);
    },

    //Permet de créer une colonne checkbox
    chekboxColumn(name, columnParams) {
      let defaultColumnParams = {
        headerName: name,
        field: name,

        cellRendererFramework: checkboxRenderer,
        cellEditorFramework: checkboxRenderer,
        cellEditorParams: { rowStartEditing: true },

        filter: "agTextColumnFilter",
        filterParams: { suppressAndOrCondition: true }
      };
      //Permet de remplacer des params de "defaultColumnParams" avec ceux passés en param (columnParams)
      return Object.assign({}, defaultColumnParams, columnParams);
    },

    //Permet de créer une colonne combobox
    comboboxColumn(name, datas, columnParams) {
      let defaultColumnParams = {
        headerName: name,
        field: name,
        cellEditorFramework: comboboxRenderer,
        cellEditorParams: datas,
        filter: false,
        sortable: false
      };
      //Permet de remplasser des params de "defaultColumnParams" avec ceux passés en param (columnParams)
      return Object.assign({}, defaultColumnParams, columnParams);
    },

    //Permet de créer une colonne autocomplete sur
    autocompleteSelect(name, columnParams) {
      let defaultColumnParams = {
        headerName: name,
        field: name,
        cellEditor: AutocompleteSelectCellEditor,
        cellEditorParams: {
          // selectData: [
          //   { label: "Canada", value: "CA", group: "North America" },
          //   { label: "United States", value: "US", group: "North America" },
          //   { label: "Uzbekistan", value: "UZ", group: "Asia" }
          // ],
          // autocomplete: {
          //   fetch: (cellEditor, text, update) => {
          //     let match = text.toLowerCase() || cellEditor.eInput.value.toLowerCase();
          //     let xmlHttp = new XMLHttpRequest();
          //     xmlHttp.onreadystatechange = () => {
          //       if (xmlHttp.readyState === 4 && xmlHttp.status === 200) {
          //         let data = JSON.parse(xmlHttp.responseText);
          //         let items = data.map(d => ({ value: d.numericCode, label: d.name, group: d.region }));
          //         update(items);
          //       }
          //       if (xmlHttp.status === 404) {
          //         update(false);
          //       }
          //     };
          //     xmlHttp.open("GET", `https://restcountries.eu/rest/v2/name/${match}`, true);
          //     xmlHttp.send(null);
          //   }
          // },
          placeholder: "Select an option"
        },
        valueFormatter: params => {
          if (params.value) {
            return params.value.label || params.value.value || params.value;
          }
          return "";
        },
        editable: true
      };
      //Permet de remplasser des params de "defaultColumnParams" avec ceux passés en param (columnParams)
      return Object.assign({}, defaultColumnParams, columnParams);
    },

    //Permet de créer une colonne button
    buttonColumn(name, datas, columnParams) {
      let defaultColumnParams = {
        headerName: name,
        field: name,
        cellRendererFramework: buttonColumnRenderer,
        cellRendererParams: datas,
        filter: false,
        sortable: false
      };
      //Permet de remplacer des params de "defaultColumnParams" avec ceux passés en param (columnParams)
      return Object.assign({}, defaultColumnParams, columnParams);
    },

    //Permet de créer une colonne buttonDisablable
    buttonDisablableColumn(name, datas, columnParams) {
      let defaultColumnParams = {
        headerName: name,
        field: name,
        cellRendererFramework: buttonDisablableColumnRenderer,
        cellRendererParams: datas,
        filter: false,
        sortable: false
      };
      //Permet de remplacer des params de "defaultColumnParams" avec ceux passés en param (columnParams)
      return Object.assign({}, defaultColumnParams, columnParams);
    },

    //Permet de créer une colonne buttonHide
    buttonHideColumn(name, datas, columnParams) {
      let defaultColumnParams = {
        headerName: name,
        field: name,
        cellRendererFramework: buttonHideColumnRenderer,
        cellRendererParams: datas,
        filter: false,
        sortable: false
      };
      //Permet de remplacer des params de "defaultColumnParams" avec ceux passés en param (columnParams)
      return Object.assign({}, defaultColumnParams, columnParams);
    },

    //Permet de créer une colonne badge
    badgeColumn(name, columnParams) {
      let defaultColumnParams = {
        headerName: name,
        field: name,
        cellRendererFramework: badgeColumnRenderer,
        filter: false,
        sortable: false
      };
      //Permet de remplacer des params de "defaultColumnParams" avec ceux passés en param (columnParams)
      return Object.assign({}, defaultColumnParams, columnParams);
    },

    //Permet de créer une colonne date (columnParams = objet a rajouter ou remplacer sur le défaut ex: { headerName: 'myName' })
    dateColumn(name, columnParams) {
      let defaultColumnParams = {
        headerName: name,
        field: name,
        filter: "agDateColumnFilter",
        valueFormatter: data => (data.value ? moment(data.value).format("L") : ""),
        filterParams: {
          filterOptions: ["equals", "inRange"],
          suppressAndOrCondition: true
        },
        cellStyle: { "text-align": "center" }
      };
      //Permet de remplacer des params de "defaultColumnParams" avec ceux passés en param (columnParams)
      return Object.assign({}, defaultColumnParams, columnParams);
    },

    //Permet de créer une colonne date + heure (columnParams = objet a rajouter ou remplacer sur le défaut ex: { headerName: 'myName' })
    dateFullColumn(name, columnParams) {
      let defaultColumnParams = {
        headerName: name,
        field: name,
        filter: "agDateColumnFilter",
        valueFormatter: data => (data.value ? moment(data.value).format("DD/MM/YY - HH:mm") : ""),
        filterParams: {
          filterOptions: ["equals", "inRange"],
          suppressAndOrCondition: true
        },
        cellStyle: { "text-align": "center" }
      };
      //Permet de remplacer des params de "defaultColumnParams" avec ceux passés en param (columnParams)
      return Object.assign({}, defaultColumnParams, columnParams);
    },

    //Permet de créer une colonne icône
    iconeColumn(name, columnParams) {
      let defaultColumnParams = {
        headerName: name,
        field: name,
        cellRendererFramework: iconeColumnRenderer,
        filter: false,
        sortable: false
      };
      //Permet de remplacer des params de "defaultColumnParams" avec ceux passés en param (columnParams)
      return Object.assign({}, defaultColumnParams, columnParams);
    },

    // Resize toute les colonnes non pinned
    autoSizeAllColumns() {
      var allColumnIds = [];
      this.gridOptions.columnApi.getAllColumns().forEach(function(column) {
        if (column.pinned == null) {
          allColumnIds.push(column.colId);
        }
      });
      this.gridOptions.columnApi.autoSizeColumns(allColumnIds);
    },

    fillListWithFilterAndSort(params) {
      let query = {};
      query.offset = params.startRow;

      query.limit = params.endRow - params.startRow;

      var re = /\./gi;
      let filterModelKey = Object.keys(params.filterModel);
      if (filterModelKey.length != 0) {
        query.filters = [];

        for (let key in filterModelKey) {
          let col = filterModelKey[key];
          let queryFilter = params.filterModel[col];
          let queryFilterType = "";
          let queryFilterValue = queryFilter.filter;
          if (col) {
            switch (queryFilter.type) {
              case "equals":
                queryFilterType = "EQ";
                break;
              case "notEqual":
                queryFilterType = "NEQ";
                break;
              case "lessThan":
                queryFilterType = "LT";
                break;
              case "greaterThan":
                queryFilterType = "GT";
                break;
              case "lessThanOrEqual":
                queryFilterType = "LTE";
                break;
              case "greaterThanOrEqual":
                queryFilterType = "GTE";
                break;
              case "contains":
                queryFilterValue = "%" + queryFilterValue + "%";
                queryFilterType = "LIKE";
                break;
              case "endsWith":
                queryFilterValue = "%" + queryFilterValue;
                queryFilterType = "LIKE";
                break;
              case "startsWith":
                queryFilterValue = queryFilterValue + "%";
                queryFilterType = "LIKE";
                break;
              case "notContains":
                queryFilterValue = "%" + queryFilterValue + "%";
                queryFilterType = "LIKE";
                break;
              case "inRange":
                queryFilterType = "IN";
                break;
              default:
            }

            var field = col.replace(re, "");
            //Pour les dates il faut les formater avant de les envoyer
            if (col == "date" || col.toLowerCase().includes("date")) {
              //Je considère que pour une date si on fait un "inRange" ça veut dire de telle date à telle date
              if (queryFilterType == "IN") {
                query.filters.push({ type: "GTE", field: field, value: moment(queryFilter.dateFrom).format("Y-MM-DD") + "T00:00:00" });
                query.filters.push({ type: "LT", field: field, value: moment(queryFilter.dateTo).format("Y-MM-DD") + "T00:00:00" });
              } else if (queryFilterType == "EQ") {
                query.filters.push({ type: "GTE", field: field, value: moment(queryFilter.dateFrom).format("Y-MM-DD") + "T00:00:00" });
                query.filters.push({
                  type: "LT",
                  field: field,
                  value:
                    moment(queryFilter.dateFrom)
                      .add(1, "days")
                      .format("Y-MM-DD") + "T00:00:00"
                });
              } else {
                query.filters.push({ type: queryFilterType, field: field, value: moment(queryFilter.dateFrom).format() });
              }
            } else {
              query.filters.push({ type: queryFilterType, field: field, value: queryFilterValue });
            }
          }
        }
      }

      if (params.sortModel.length > 0) {
        query.sorts = [];

        for (let key in Object.keys(params.sortModel)) {
          let sort = params.sortModel[key].sort === "asc" ? "asc" : "dsc";

          //Enleve les points ex: variant.product.ean -> variantproductean

          params.sortModel[key].colId = params.sortModel[key].colId.replace(re, "");

          query.sorts.push({ field: params.sortModel[key].colId, direction: sort });
        }
      }
      return query;
    },

    // eslint-disable-next-line no-unused-vars
    onRemoveSelected(row) {
      return;
    },

    // eslint-disable-next-line no-unused-vars
    onAddSelected() {
      var cols = this.gridOptions.columnApi.getAllColumns();
      let firstColNameEditable;

      // Get the first column editable
      for (var i = 0; i < cols.length; i++) {
        if (cols[i].colDef.editable) {
          firstColNameEditable = cols[i].colDef.headerName;
          break;
        }
      }

      var rows = [{}];
      // this.gridApi.applyTransaction({ add: row });
      // var res = this.gridOptions.api.applyTransaction({ add: rows });
      // console.log(res);
      this.gridOptions.api.setPinnedTopRowData(rows);

      this.gridOptions.api.setFocusedCell(0, firstColNameEditable, "top");
      this.gridOptions.api.startEditingCell({
        rowIndex: 0,
        colKey: firstColNameEditable,
        rowPinned: "top",
        keyPress: null,
        charPress: null
      });
      // this.gridOptions.api.startEditingCell({
      //   rowIndex: 0,
      //   colKey: firstColNameEditable
      // });

      return;
    },

    onRowDataChanged() {
      Vue.nextTick(() => {
        this.gridOptions.api.sizeColumnsToFit();
      });
    },
    onExport() {
      return;
    },

    // eslint-disable-next-line no-unused-vars
    create_csv_link_based_on_column(cell) {
      return;
    },

    // eslint-disable-next-line no-unused-vars
    onRowValueChanged(row) {
      return;
    },

    onRowEditingStarted(row) {
      // Récuperation de l'ancienne valeur pour la mettre à dispo
      this.editingOldValues = Object.assign({}, row.data);
    },

    onRowEditingStopped(row) {
      this.editingNewValues = Object.assign({}, row.data);
      this.gridOptions.api.setPinnedTopRowData([]);
    },

    // eslint-disable-next-line no-unused-vars
    onCellEditingStarted(row) {
      return;
    },

    // eslint-disable-next-line no-unused-vars
    onCellEditingStopped(row) {
      return;
    },

    // eslint-disable-next-line no-unused-vars
    onCellClicked(cel) {
      //// checked the checkbox on click cellule
      //let htmlElements = cel.event.srcElement.children
      //for (var i = 0; i < htmlElements.length; i++) {
      //  if (htmlElements[i].type === 'checkbox') {
      //    htmlElements[i].click()
      //    return
      //  }
      //}
    },

    // eslint-disable-next-line no-unused-vars
    onRowSelected(row) {
      // vérification d'une ligne selectionnée pour afficher le bouton corbeille
      if (this.gridOptions.api.getSelectedRows().length > 0) this.isDeleteButtonDisabled = false;
      else this.isDeleteButtonDisabled = true;
    },

    // eslint-disable-next-line no-unused-vars
    onSelectionChanged(row) {
      return;
    },

    // Refresh des elements de la grille
    async refreshData() {
      let gridApi = this.gridOptions.api;
      let pageNumber = gridApi.paginationGetCurrentPage();

      gridApi.setDatasource(this.dataSource);

      gridApi.paginationGoToPage(pageNumber);
    },

    // eslint-disable-next-line no-unused-vars
    onModelUpdated(model) {
      let gridApi = this.gridOptions.api;

      if (gridApi.getDisplayedRowCount() < 1) {
        gridApi.showNoRowsOverlay();
      } else {
        gridApi.hideOverlay();
      }
    },

    clearFilters() {
      let gridApi = this.gridOptions.api;

      gridApi.setFilterModel(null);
      gridApi.onFilterChanged();
    },

    // eslint-disable-next-line no-unused-vars
    onFirstDataRendered(params) {
      //params.api.sizeColumnsToFit();
    }
  },

  beforeMount() {
    this.gridOptions = {
      components: {
        loadingRenderer: params => {
          if (params.value !== undefined) {
            return params.value;
          } else {
            return '<i class="fas fa-spinner fa-pulse"></i>';
          }
        }
      },
      rowModelType: "infinite",
      rowDeselection: true,
      rowSelection: "single",
      cacheOverflowSize: 2,
      maxConcurrentDatasourceRequests: 2,
      navigateToNextCell: this.customKeyboardNavigation,
      infiniteInitialRowCount: 1,
      maxBlocksInCache: 1,
      colResizeDefault: "shift",
      paginationPageSize: 20,
      cacheBlockSize: 20,
      rowHeight: 32,
      headerHeight: 40,
      getRowNodeId: item => {
        return item.id;
      }
    };
    this.defaultColDef = {
      resizable: true,
      filter: true,
      sortable: true
    };

    this.localeText = {
      page: "page",
      to: "-",
      of: "/",
      loadingOoo: "Chargement...",
      searchOoo: "Rechercher...",
      equals: "Égal",
      notEqual: "Différent",
      lessThan: "Infernieur à",
      greaterThan: "Superieur à",
      lessThanOrEqual: "Inferieur ou égal à",
      greaterThanOrEqual: "Superieur ou égal à",
      inRange: "Compris entre",
      contains: "Contient",
      notContains: "Ne contient pas",
      startsWith: "Commence par",
      endsWith: "Fini par",
      andCondition: "Et",
      orCondition: "Ou",
      filterOoo: "Filtrer..."
    };

    this.overlayLoadingTemplate = '<span class="ag-overlay-loading-center"><i class="fas fa-spinner fa-pulse"></i> Patientez svp...</span>';
    this.overlayNoRowsTemplate = '<span class="ag-overlay-loading-center">Pas de résultat</span>';
  },

  mounted() {
    let heightToRemove = 173;
    if (this.screenW < this.tabletW) {
      heightToRemove = 100;
    }

    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
    var eGridDiv = document.body.querySelector(`#${this.id}`);
    eGridDiv.style.height = window.innerHeight - heightToRemove + "px";
    this.gridApi.doLayout();
    window.addEventListener("resize", function() {
      eGridDiv.style.height = this.innerHeight - heightToRemove + "px";
      this.gridApi.doLayout();
    });
  }
};
</script>
